<template>
    <div>
        <slot name="title">
            <p>We like to see ourselves as an extension of your business, building processes and functionality to enable transparency of service. They are at your disposal during this process and are only a call or email away.</p>
        </slot>
        <p class="mb-2 poppins-semi-bold">Migration Agent:</p>
        <p class="mb-0">
            <strong>{{manager.name}}</strong>
        </p>
        <p class="mb-0" v-if="manager.marn">MARN: {{manager.marn}}</p>
        <p class="mb-0" v-if="manager.contact_phone">Phone: {{manager.contact_phone}}</p>
        <p class="mb-0" v-if="manager.contact_mobile">Mobile: {{manager.contact_mobile}}</p>
        <p class="mb-0" v-if="manager.email">Email: {{manager.email}}</p>
    </div>
</template>

<script>
/* eslint-disable */
import _isEmpty from 'lodash/isEmpty';

export default {
    name: 'ManagersComponent',
    data () {
        return {
            manager: {}
        };
    },

    async created () {
        let project = this.getProject();
        this.manager = project.case_manager || [];
    }
}
</script>